module.exports = __webpack_public_path__ + "static/media/Right legs23.70f5ba2c.png";